import { buildSlice, CommonState } from '~libs/reduxUtils';

import { getAll, getOne, typePrefix } from '~lookups/actions/invoiceStatuses';

import { InvoiceStatus } from '../models';

const initialState: CommonState<InvoiceStatus> = {
  loading: 'idle',
  hasLoaded: false,
  error: null,
  rows: [],
  row: undefined,
};

const slice = buildSlice<CommonState<InvoiceStatus>, InvoiceStatus>(typePrefix, initialState, {
  commonConfig: { getAll, getOne },
});

export const { clear, updateParams } = slice.actions;
export default slice.reducer;
